<template>
    <el-container class="app-layout">
        <!-- Navbar -->
        <el-header class="app-header p-0" height="1">
            <el-row justify="space-between" align="middle" class="p-2 col-12">
                <el-col class="col-auto">
                    <el-button
                        icon="Menu"
                        @click="toggleSidebar" 
                        class="menu-toggle-button"
                    ></el-button>
                    <span class="app-title">DashBoard Beasy app</span>
                </el-col>
                <el-row align="middle" :gutter="15">
                    <el-col class="d-none d-sm-inline col-auto">
                        <el-tooltip
                            effect="light"
                            content="Modo tela cheia"
                            placement="bottom"
                        >
                            <el-icon role="button" @click="toggleFullscreen">
                                <Rank v-if="isFullscreen"/>
                                <FullScreen v-else />
                            </el-icon>
                        </el-tooltip>
                    </el-col>
                    <el-col class="col-auto">
                            <el-tooltip
                                effect="light"
                                content="Terminar sesssao"
                                placement="bottom"
                            >
                                <el-icon shape="circle" role="button" @click="logout">
                                    <SwitchButton />
                                </el-icon>
                            </el-tooltip>
                    </el-col>
                </el-row>
            </el-row>
        </el-header>
        <!-- ./Navbar -->

        <!-- Sidebar and Main Content -->
        <el-container>
            <el-aside class="app-sidebar col-auto">
                <el-menu 
                    :collapse="!isSidebarOpen"
                    :default-active="activeMenu" 
                    active-text-color="#ffd04b"
                    background-color="#545c64"
                    class="el-menu-vertical-demo" 
                    router 
                    unique-opened
                    text-color="#fff"
                >
                    <el-menu-item index="/profile" title="Perfil">
                        <el-icon><User /></el-icon>
                        <span>Perfil</span>
                    </el-menu-item>
                    <el-sub-menu title="Clubes" index="1">
                        <template #title>
                            <el-icon><ShoppingCartFull /></el-icon>
                            <span>Pedidos</span>
                        </template>
                        <el-menu-item index="/dashboard" title="Pedidos">
                            <el-icon><WarnTriangleFilled /></el-icon>
                            <span >Pedidos pendentes</span>
                        </el-menu-item>
                        <el-menu-item index="/requests" title="Clubes">
                            <el-icon><Star /></el-icon>
                            <span >Pedidos atendidos</span>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-sub-menu title="Productos" index="2">
                        <template #title>
                            <el-icon><Present /></el-icon>
                            <span>Produtos</span>
                        </template>
                        <el-menu-item index="/products" title="Productos">
                            <el-icon><View /></el-icon>
                            <span>Listar produtos</span>
                        </el-menu-item>
                        <el-menu-item @click="() => {showModal(2)}" index="#1" title="Novo producto">
                            <el-icon><CirclePlusFilled /></el-icon>
                            <span >Adicionar novo</span>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-sub-menu title="Categorias" index="3">
                        <template #title>
                            <el-icon><Collection /></el-icon>
                            <span>Categorias</span>
                        </template>
                        <el-menu-item index="/categories" title="Categorias">
                            <el-icon><View /></el-icon>
                            <span >Listar categorias</span>
                        </el-menu-item>
                        <el-menu-item title="Nova categoria" index="#2" @click="() => {showModal(0)}">
                            <el-icon><CirclePlusFilled /></el-icon>
                            <span >Adicionar nova</span>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-sub-menu title="Vídeos" index="4">
                        <template #title>
                            <el-icon><VideoCamera /></el-icon>
                            <span>Vídeos promocionais</span>
                        </template>
                        <el-menu-item index="/videos" title="Vídeos">
                            <el-icon><View /></el-icon>
                            <span>Listar videos</span>
                        </el-menu-item>
                        <el-menu-item @click="() => {showModal(7)}" title="Novo Vídeos" index="#3">
                            <el-icon><CirclePlusFilled /></el-icon>
                            <span >Adicionar novo</span>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-menu-item index="/stores" title="Store">
                        <el-icon><shop /></el-icon>
                        <span>Lojas</span>
                    </el-menu-item>
                    <el-sub-menu title="usuarios" index="5" v-if="isMaster">
                        <template #title>
                            <el-icon><Avatar /></el-icon>
                            <span>Admins e vendedores</span>
                        </template>
                        <el-menu-item index="/users" title="Admins e vendedores">
                            <el-icon><View /></el-icon>
                            <span>Ver admins e vendedores</span>
                        </el-menu-item>
                        <el-menu-item @click="() => {showModal(1)}" title="Novo Admin ou Vendedor" index="#4">
                            <el-icon><CirclePlusFilled /></el-icon>
                            <span >Novo admin ou Vendedor</span>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-sub-menu title="Lugares" index="6">
                        <template #title>
                            <el-icon><MapLocation /></el-icon>
                            <span>Locais Físicos</span>
                        </template>
                        <el-menu-item index="/places" title="Locais">
                            <el-icon><LocationFilled /></el-icon>
                            <span >Listar lugares</span>
                        </el-menu-item>
                        <el-menu-item @click="() => {showModal(3)}" title="Novo Local" index="#5">
                            <el-icon><AddLocation /></el-icon>
                            <span >Adicionar novo</span>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-sub-menu title="Afiliados" index="9">
                        <template #title>
                            <el-icon><User /></el-icon>
                            <span>Afiliados</span>
                        </template>
                        <el-menu-item index="/affiliates" title="Locais">
                            <el-icon><View /></el-icon>
                            <span>Listar afiliados</span>
                        </el-menu-item>
                        <el-menu-item  title="Pedidos de levantamento" index="/withdraws">
                            <el-icon><Coin /></el-icon>
                            <span>Pedidos de levantamento</span>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-sub-menu title="Eventos" index="7">
                        <template #title>
                             <el-icon><Calendar /></el-icon>
                            <span>Eventos</span>
                        </template>
                        <el-menu-item index="/events" title="Listar eventos">
                            <el-icon><View /></el-icon>
                            <span >Listar eventos</span>
                        </el-menu-item>
                        <el-menu-item @click="() => {showModal(5)}" title="Novo evento" index="#">
                            <el-icon><Plus /></el-icon>
                            <span >Publicar novo</span>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-sub-menu title="Transportadoras" index="8">
                        <template #title>
                            <el-icon><OfficeBuilding /></el-icon>
                            <span>Empresas de Transporte</span>
                        </template>
                        <el-menu-item index="/companies" title="Empresas de transporte">
                            <el-icon><View /></el-icon>
                            <span >Empresas de Transporte</span>
                        </el-menu-item>
                        <el-menu-item @click="() => {showModal(6)}" title="Nova empresa de transporte" index="#6">
                            <el-icon><Plus /></el-icon>
                            <span >Adicionar novo</span>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-sub-menu title="Publicidade" index="10">
                        <template #title>
                            <el-icon><Promotion /></el-icon>
                            <span>Banners de Publicidade</span>
                        </template>
                        <el-menu-item index="/ad-banners" title="Banners publicitarios">
                            <el-icon><View /></el-icon>
                            <span>Banners publicitarios</span>
                        </el-menu-item>
                        <el-menu-item @click="() => {showModal(8)}" title="Nova Publicidade" index="#10">
                            <el-icon><Plus /></el-icon>
                            <span>Adicionar novo</span>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-menu-item index="/travel" title="Viagens">
                        <el-icon><Van /></el-icon>
                        <span >Listar viagens Marcadas</span>
                    </el-menu-item>
                    <el-menu-item index="/message" title="Mensagem">
                        <el-icon><Message /></el-icon>
                        <span >Enviar mensagem</span>
                    </el-menu-item> 
                    <el-menu-item index="/reports" title="Relatorios">
                        <el-icon><Coin /></el-icon>
                        <span >Relatórios financeiros</span>
                    </el-menu-item> 
                </el-menu>
            </el-aside>
            <el-main class="">
                <router-view></router-view>
            </el-main>
        </el-container>
        <!-- ./Sidebar and Main Content -->

        <ElButton circle class="back-button" plain type="primary" size="large" @click="back">
            <ElIcon>
                <Back />
            </ElIcon>
        </ElButton>
        <!-- Modals Create -->
        <modal-component 
            :header="modalTitles[openModal]"
            footer="" cardclass="col-12 col-md-8 col-lg-6"
            v-if="modalTitles[openModal]"
            @close="hideModal"
        >
            <create-category v-if="openModal == 0" />
            <create-user v-if="openModal == 1 && isMaster" />
            <create-product v-if="openModal == 2" />
            <create-place v-if="openModal == 3" />
            <create-prop v-if="openModal == 4" />
            <create-event v-if="openModal == 5" />
            <create-company v-if="openModal == 6" />
            <CreateVideo v-if="openModal == 7" />
            <CreateAdBanner v-if="openModal == 8" />
        </modal-component>
        <!-- ./Modals Create -->

    </el-container>
</template>

<script lang="ts" setup>
    import { computed, onBeforeMount, ref } from 'vue';
    import { useStore } from 'vuex';
    import { useRouter } from 'vue-router';
    import { useFullscreen } from '@vueuse/core'
    import Api from '@/services/api'
    import CreateCategory from '@/components/modals/creates/CreateCategory.vue'
    import CreateUser from '@/components/modals/creates/CreateUser.vue';
    import CreateProduct from '@/components/modals/creates/CreateProduct.vue'
    import CreatePlace from '@/components/modals/creates/CreatePlace.vue'
    import CreateProp from '@/components/modals/creates/CreateProp.vue'
    import ModalComponent from '@/components/modals/ModalComponent.vue'
    import CreateEvent from '@/components/modals/creates/CreateEvent.vue';
    import CreateCompany from '@/components/modals/creates/CreateCompany.vue';
    import { ElButton, ElIcon } from 'element-plus';
    import { Avatar, CirclePlusFilled, Message, MessageBox, View } from '@element-plus/icons-vue';
    import CreateVideo from '@/components/modals/creates/CreateVideo.vue';
import CreateAdBanner from '@/components/modals/creates/CreateAdBanner.vue';

    const store = useStore();
    const router = useRouter();
    const isMaster = ref<boolean>(false)

    const openModal = computed(() => store.getters.openModal)

    const isSidebarOpen = ref(false);
    const activeMenu = ref<string>(store.getters.route)

    const modalTitles = ref<Array<string>>([
        'Criar categoria de produtos',
        'Cadastrar novo entregador/Administrador',
        'Adicionar produto',
        'Cadastrar Local de propaganda',
        'Adicionar propriedade',
        'Publicar evento',
        'Nova Transportadora',
        'Novo vídeo',
        'Novo Banner publicitario'
    ])

    const updateMenu = () => {
        const item = sessionStorage.getItem("user")
        console.log(item)
        const user = item ? JSON.parse(item):{}
        
        isMaster.value = user.role == 'master'
    }

    router.beforeEach(route => {
        activeMenu.value = route.path
        updateMenu()
    })
    
    onBeforeMount(() => updateMenu())
    // onBeforeUpdate(() => updateMenu())

    const toggleSidebar = () => {
        isSidebarOpen.value = !isSidebarOpen.value;
    };

    // const handleLogout = () => {
    //     store.dispatch('logout').then(() => {
    //         router.push({ name: 'Login' });
    //     });
    // };

    const back = () => {
        router.back()
    }

    const { isFullscreen, toggle: toggleFullscreen } = useFullscreen();
    
    const logout = async () => {
        sessionStorage.removeItem("user")
        Api.post("/auth/logout", {})
        store.dispatch('logout')
        router.push("/")
    }

    const showModal = (n: number) => {
        store.commit('setOpenModal', n)
        console.log(n)
    }
    const hideModal = () => {store.commit('setOpenModal', -1)}
</script>

<style scoped lang="scss">
.app-layout {
    height: 100vh;

    .app-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        background-color: #409EFF;
        color: white;
        
        .app-title {
            font-size: 1.2em;
        }

        .menu-toggle-button {
            margin-right: 10px;
        }
    }

    .app-sidebar {
        transition: all .3s;
    
        .el-menu-vertical-demo {
            height: 100%;
            &:not(.el-menu--collapse) {
                width: 240px;
            }
        }
    }

    .back-button {
        position: fixed;
        bottom: 2rem;
        right: 1rem;
        z-index: 1020;
    }
}
</style>
